module.exports = __webpack_public_path__ + "img/company_icon6.514ba0f4.png";